export const SET_ACTIVE_NEWS = 'seller/SET_ACTIVE_NEWS'

const initialState = {
  data: {}
}

export default (state = initialState, action) => {

  switch (action.type) {

    case SET_ACTIVE_NEWS:
      return {
        ...state,
        data: action.data
      }

    default:
      return state
  }
}

export const setActiveNews = (data) => {
  return dispatch => {
    dispatch({
      type: SET_ACTIVE_NEWS,
      data
    })
  }
}
